import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="cdh-footer">
      <div className="cdh-footer__logo">
        © 2026 ScriptedCAD · Chennai
      </div>
      <div className="cdh-footer__links">
        <Link to="/about">About</Link>
        <Link to="/projects">What We Built</Link>
        {/* Plain anchor: /resources is proxied to the backend, so this needs a
            real navigation rather than a client side route change. */}
        <a href="/resources">Free Resources</a>
        <Link to="/workbooks">Workbooks</Link>
        <Link to="/community">Community</Link>
        <a
          href="https://linkedin.com/in/prasath-r-5584343b7"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>
      </div>
    </footer>
  );
}

export default Footer;
